export const allImages = [
    'https://jumunonasmsverify.s3.amazonaws.com/jumunona_products/911/0680659.jpg',
    'https://jumunonasmsverify.s3.amazonaws.com/jumunona_products/911/0680660.jpg',
    'https://jumunonasmsverify.s3.amazonaws.com/jumunona_products/911/683860270184677918.jpg',
    'https://jumunonasmsverify.s3.amazonaws.com/jumunona_products/911/683860270184677926.jpg',
    'https://jumunonasmsverify.s3.amazonaws.com/jumunona_products/911/683860270184677915.jpg',
    'https://jumunonasmsverify.s3.amazonaws.com/jumunona_products/911/683860270184677902.jpg',
    'https://jumunonasmsverify.s3.amazonaws.com/jumunona_products/911/0680661.jpg'
];